import { useEffect, useMemo } from 'react';
import { EventToolbox } from 'client/utils/event-toolbox';
import { DEALER_EVENTS } from 'site-modules/dealerships/utils/dealer-events';
import { getQuery } from 'client/utils/location';
import { isReferredUrlFromEdmunds } from 'site-modules/dealerships/utils/is-referred-url-from-edmunds';

export const useTrackInternalReferrer = location => {
  const query = useMemo(() => getQuery(location), [location]);

  const hasReferrer = useMemo(() => {
    return query.referrer === 'true' || isReferredUrlFromEdmunds();
  }, [query.referrer]);

  useEffect(() => {
    if (hasReferrer) {
      EventToolbox.fireCustomEvent(DEALER_EVENTS.INTERNAL_REFERRER);
    }
  }, [hasReferrer]);
};
